import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Checkbox, ConfirmationModal, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { LegalTermsUsedIn } from '../../../models/legal-terms/model';
import styles from './PropagationModal.module.scss';
export const { PropagationModalTID } = getTestIds();
const usedInTestIds = {
    [LegalTermsUsedIn.Draft]: PropagationModalTID.DraftCheckbox,
    [LegalTermsUsedIn.ProposalTemplate]: PropagationModalTID.ProposalTemplateCheckbox
};
export const PropagationModal = (param)=>{
    let { usedIn, isSaving, onConfirm, onCancel } = param;
    const { t: texts } = useLocaleKeys('components.legalTermsDropdown');
    const { t: commonTexts } = useLocaleKeys('common');
    const [updateRelationshipDrafts, setUpdateRelationshipDrafts] = useState(false);
    const [updateProposalTemplates, setUpdateProposalTemplates] = useState(false);
    const usedInLabels = {
        [LegalTermsUsedIn.Draft]: texts.propagationDraftLabel(),
        [LegalTermsUsedIn.ProposalTemplate]: texts.propagationProposalTemplateLabel()
    };
    const handleConfirm = ()=>{
        onConfirm({
            updateRelationshipDrafts,
            updateProposalTemplates
        });
    };
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'propagation_confirm'
            },
            secondaryButton: {
                name: 'propagation_cancel'
            }
        },
        title: texts.propagationTitle(),
        width: "600px",
        testId: PropagationModalTID.Root(),
        textAlignCenter: false,
        content: /*#__PURE__*/ _jsxs("div", {
            className: styles.propagationContent,
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    children: texts.propagationDocumentUsed()
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    children: texts.propagationUpdatePrompt()
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.propagationCheckboxes,
                    children: [
                        ...usedIn
                    ].sort().map((usedInValue)=>/*#__PURE__*/ _jsx(Checkbox, {
                            inline: true,
                            testId: usedInTestIds[usedInValue](),
                            checked: usedInValue === LegalTermsUsedIn.Draft ? updateRelationshipDrafts : updateProposalTemplates,
                            onChange: (e)=>{
                                if (usedInValue === LegalTermsUsedIn.Draft) {
                                    setUpdateRelationshipDrafts(e.target.checked);
                                } else {
                                    setUpdateProposalTemplates(e.target.checked);
                                }
                            },
                            bi: {
                                name: 'legal_terms_propagate_target',
                                data: {
                                    used_in: usedInValue
                                }
                            },
                            children: /*#__PURE__*/ _jsx(Typography, {
                                children: usedInLabels[usedInValue]
                            })
                        }, usedInValue))
                })
            ]
        }),
        primaryButtonLabel: commonTexts.buttons.saveChanges(),
        secondaryButtonLabel: commonTexts.buttons.cancel(),
        primaryButtonLoading: isSaving,
        onPrimaryButtonClick: handleConfirm,
        onSecondaryButtonClick: onCancel
    });
};
